import React, { ReactElement, useRef, useState } from 'react';

import { ContentCard } from '../../../../shared/contentCard';
import * as S from './CardScroll.styles';

type Prop = {
 list:{
  title: string;
  description: string;
  link: string;
 }[]
 auraColor: 'blue' | 'red';
};

export const CardScroll = ({ list, auraColor }: Prop): ReactElement => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [startX, setStartX] = useState<number>(0);
  const [scrollLeft, setScrollLeft] = useState<number>(0);


  const startDragging = (e: React.MouseEvent<HTMLDivElement>) => {
    const container = scrollRef.current;
    if (container) {
      setIsDragging(true);
      setStartX(e.pageX - container.offsetLeft);
      setScrollLeft(container.scrollLeft);
    }
  };

  const stopDragging = () => {
    setIsDragging(false);
  };

  const onDragging = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isDragging) return;

    const container = scrollRef.current;
    if (container) {
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 4; // The 4 multiplier adjusts the sensitivity
      container.scrollLeft = scrollLeft - walk;
    }
  };

  return (
    <S.CardsWrapper         
      ref={scrollRef}
      onMouseDown={startDragging}
      onMouseLeave={stopDragging}
      onMouseMove={onDragging}
      onMouseUp={stopDragging}  
    >
      {list.map(({ title, description, link }) => (
        <ContentCard key={link} auraColor={auraColor} description={description} link={link} title={title} />
      ))}
    </S.CardsWrapper>
  );
};
